export default function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@popperjs/core/lib/utils/getAltAxis.js
// module id = 982
// module chunks = 3